import React, { useEffect, useState } from "react";

import { useUserInfos } from "../roomservice/maps";

import useSound from "use-sound";
import { BOT_NAME } from "../consts";
const enterSfx = require("../assets/sounds/enter.mp3").default;
const exitSfx = require("../assets/sounds/exit.mp3").default;

export default function BuddyList() {
  const userInfos = useUserInfos();
  const [playEnter] = useSound(enterSfx, {
    volume: 0.5,
  });
  const [playExit] = useSound(exitSfx, { volume: 0.5 });

  const number_people = Object.values(userInfos).filter(
    (user) => user.name && user.name !== BOT_NAME
  ).length;

  const [prevNumber, setPrevNumber] = useState(number_people);
  useEffect(() => {
    if (number_people > prevNumber) {
      playEnter();
    } else if (number_people < prevNumber) {
      playExit();
    }
    setPrevNumber(number_people);
  }, [number_people, playEnter, playExit, prevNumber]);

  return <></>;
}
